import React, {  useEffect, useRef, useState } from "react";
import { Link } from "react-scroll";
import { motion, AnimatePresence } from "framer-motion";
import Hamburger from "hamburger-react";
import "bootstrap/dist/css/bootstrap.min.css"
import LanguageSelector from "./LanguageSelector";
import useTranslation from "../Constant";
import { NavLink, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Navbar = ({theme,darkMode}) => {
  const [toggle, setToggle] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const navRef = useRef(null);
  const navigate = useNavigate();

  const Constant = useTranslation()
  const location = useLocation();
  const [isGalleryPage, setIsGalleryPage] = useState(false);

  function toggleTheme() {
    if (darkMode === true) {
      theme.dispatch({ type: "LIGHTMODE" });
    } else {
      theme.dispatch({ type: "DARKMODE" });
    }
  }

  useEffect(() => {
    // Update state on every route change
    console.log(location.pathname === "/galary","location.pathname")
    setIsGalleryPage(location.pathname !== "/");
  }, [location.pathname]);

  useEffect(() => {
    const syncFullscreen = () => {
      setIsFullscreen(
        Boolean(
          document.fullscreenElement || document.webkitFullscreenElement
        )
      );
    };
    document.addEventListener("fullscreenchange", syncFullscreen);
    document.addEventListener("webkitfullscreenchange", syncFullscreen);
    syncFullscreen();
    return () => {
      document.removeEventListener("fullscreenchange", syncFullscreen);
      document.removeEventListener("webkitfullscreenchange", syncFullscreen);
    };
  }, []);

  const toggleFullscreen = async () => {
    const root = document.documentElement;
    try {
      if (document.fullscreenElement || document.webkitFullscreenElement) {
        if (document.exitFullscreen) await document.exitFullscreen();
        else if (document.webkitExitFullscreen)
          await document.webkitExitFullscreen();
      } else {
        if (root.requestFullscreen) await root.requestFullscreen();
        else if (root.webkitRequestFullscreen)
          root.webkitRequestFullscreen();
      }
    } catch (e) {
      console.warn("Fullscreen:", e);
    }
  };

  
  return (
    <>
      <nav
        ref={navRef}
        className={
          darkMode
            ? "bg-white border-gray-200 z-50 shadow-lg md:px-8 px-1 fixed w-full top-0"
            : "bg-gray-700 border-gray-200 z-50 shadow-lg md:px-8 px-1 fixed w-full top-0"
        }
      >
        <div className="flex justify-between items-center gap-3 py-2 md:py-4 md:px-2 pl-2 mx-auto">
          <div className="flex items-center cursor-pointer">
            <a
              href="https://www.linkedin.com/in/29159rajusingh/"
              target="_blank"
              className={
                darkMode
                  ? "text-xl font-medium text-decoration-none whitespace-nowrap text-black"
                  : "text-xl font-medium text-decoration-none whitespace-nowrap text-white"
              }
            >
              <img
                src={Constant.Profile_Photo}
                width={"25px"}
                height="25px"
                className=""
                style={{ borderRadius: "45%" }}
                alt="Profile_photo"
              />
            </a>
          </div>
          {/* for desktop */}
          <div className="hidden justify-between items-center w-full md:flex md:w-auto ">
            {/* Google Search */}
            <button
              onClick={() => navigate("/google-search")}
              className="bg-blue-600 text-white px-3 py-2 rounded-lg shadow-md hover:shadow-xl transition hover:bg-blue-700"
            >
              🔍 Search
            </button>

            {/* Galary */}
            {!isGalleryPage ? (
              <div>
                <NavLink
                  to="/galary"
                  className={({ isActive }) =>
                    darkMode
                      ? "block py-2 px-3 rounded-md " +
                        (isActive
                          ? "bg-blue-500 text-white"
                          : "text-black hover:bg-blue-500 hover:text-white")
                      : "block py-2 px-3 rounded-md " +
                        (isActive
                          ? "bg-blue-500 text-white"
                          : "text-white hover:bg-blue-500 hover:text-black")
                  }
                >
                  Gallery
                </NavLink>
              </div>
            ) : (
              /* Home & contact*/
              <>
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    darkMode
                      ? "block py-2 px-3 rounded-md " +
                        (isActive
                          ? "bg-blue-500 text-white"
                          : "text-black hover:bg-blue-500 hover:text-white")
                      : "block py-2 px-3 rounded-md " +
                        (isActive
                          ? "bg-blue-500 text-white"
                          : "text-white hover:bg-blue-500 hover:text-black")
                  }
                >
                  Home
                </NavLink>

                <Link
                  to={"contact"}
                  activeClass={"text-white bg-blue-500"}
                  spy={true}
                  smooth={true}
                  className={
                    darkMode
                      ? "block py-2 px-3 text-black hover:bg-blue-500 hover:text-white rounded-md cursor-pointer"
                      : "block py-2 px-3 text-white hover:bg-blue-500 hover:text-black rounded-md cursor-pointer"
                  }
                >
                  {"Contact"}
                </Link>
              </>
            )}

            {/*language  */}
            {!isGalleryPage && (
              <div>
                <LanguageSelector darkMode={darkMode} />
              </div>
            )}

            <div onClick={() => toggleTheme()}>
              {darkMode ? (
                <img
                  src="https://img.icons8.com/external-flaticons-flat-flat-icons/64/000000/external-sun-lighting-flaticons-flat-flat-icons.png"
                  className="w-6 ml-6 cursor-pointer hover:scale-1.50 block"
                  alt=""
                />
              ) : (
                <img
                  src="https://img.icons8.com/external-prettycons-lineal-color-prettycons/49/000000/external-moon-astrology-and-symbology-prettycons-lineal-color-prettycons.png"
                  className="w-6 ml-6 cursor-pointer hover:scale-1.50 block"
                  alt=""
                />
              )}
            </div>

            <button
              type="button"
              onClick={toggleFullscreen}
              title={isFullscreen ? "Exit fullscreen" : "Fullscreen"}
              aria-label={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
              className={
                darkMode
                  ? "ml-3 inline-flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 bg-white/90 text-slate-800 shadow-sm transition hover:bg-slate-50 hover:border-slate-300"
                  : "ml-3 inline-flex h-9 w-9 items-center justify-center rounded-lg border border-slate-500 bg-slate-600/80 text-white shadow-sm transition hover:bg-slate-500"
              }
            >
              {isFullscreen ? (
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 9V4.5H4.5M9 9H4.5M4.5 9L9 4.5M9 15v4.5H4.5M9 15H4.5M4.5 15L9 19.5M15 9h4.5V9M15 9v4.5M15 9L19.5 4.5M15 15h4.5M15 15v-4.5m0 4.5L19.5 19.5" />
                </svg>
              ) : (
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
                </svg>
              )}
            </button>

            {!isGalleryPage && (
              <Hamburger
                toggled={toggle}
                size={22}
                duration={0.8}
                distance={"lg"}
                toggle={setToggle}
                color={darkMode ? "#000000" : "#ffffff"}
              />
            )}
          </div>

          {/* For mobile */}
          <div className="flex md:hidden items-center gap-2">
            {/*language  */}
            {!isGalleryPage && (
              <div className="ml-2">
                <LanguageSelector darkMode={darkMode} />
              </div>
            )}

            {/* Galary */}
            {!isGalleryPage ? (
              <div className="">
                <NavLink
                  to="/galary"
                  className={({ isActive }) =>
                    darkMode
                      ? "block py-2 px-3 rounded-md " +
                        (isActive
                          ? "bg-blue-500 text-white"
                          : "text-black hover:bg-blue-500 hover:text-white")
                      : "block py-2 px-3 rounded-md " +
                        (isActive
                          ? "bg-blue-500 text-white"
                          : "text-white hover:bg-blue-500 hover:text-black")
                  }
                >
                  Gallery
                </NavLink>
              </div>
            ) : (
              /* google, Home & contact*/
              <>
                <NavLink
                  to="/google-search"
                  className={({ isActive }) =>
                    darkMode
                      ? "block py-1.5 px-2 rounded-md " +
                        (isActive
                          ? "bg-blue-500 text-white"
                          : "text-black hover:bg-blue-500 hover:text-white")
                      : "block py-1.5 px-2 rounded-md " +
                        (isActive
                          ? "bg-blue-500 text-white"
                          : "text-white hover:bg-blue-500 hover:text-black")
                  }
                >
                  Google
                </NavLink>

                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    darkMode
                      ? "block py-1.5 px-2 rounded-md " +
                        (isActive
                          ? "bg-blue-500 text-white"
                          : "text-black hover:bg-blue-500 hover:text-white")
                      : "block py-1.5 px-2 rounded-md " +
                        (isActive
                          ? "bg-blue-500 text-white"
                          : "text-white hover:bg-blue-500 hover:text-black")
                  }
                >
                  Home
                </NavLink>

                <Link
                  to={"contact"}
                  activeClass={"text-white bg-blue-500"}
                  spy={true}
                  smooth={true}
                  className={
                    darkMode
                      ? "block py-1.5 px-2 text-black hover:bg-blue-500 hover:text-white rounded-md cursor-pointer"
                      : "block py-1.5 px-2 text-white hover:bg-blue-500 hover:text-black rounded-md cursor-pointer"
                  }
                >
                  {"Contact"}
                </Link>
              </>
            )}
            {/* night mode icon */}
            <div onClick={() => toggleTheme()}>
              {darkMode ? (
                <img
                  src="https://img.icons8.com/external-flaticons-flat-flat-icons/64/000000/external-sun-lighting-flaticons-flat-flat-icons.png"
                  className="w-6 cursor-pointer hover:scale-1.50 block"
                  alt=""
                />
              ) : (
                <img
                  src="https://img.icons8.com/external-prettycons-lineal-color-prettycons/49/000000/external-moon-astrology-and-symbology-prettycons-lineal-color-prettycons.png"
                  alt=""
                  className="w-6 cursor-pointer hover:scale-1.50 block"
                />
              )}
            </div>

            <button
              type="button"
              onClick={toggleFullscreen}
              title={isFullscreen ? "Exit fullscreen" : "Fullscreen"}
              aria-label={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
              className={
                darkMode
                  ? "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white/90 text-slate-800 shadow-sm transition hover:bg-slate-50"
                  : "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-slate-500 bg-slate-600/80 text-white shadow-sm transition hover:bg-slate-500"
              }
            >
              {isFullscreen ? (
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 9V4.5H4.5M9 9H4.5M4.5 9L9 4.5M9 15v4.5H4.5M9 15H4.5M4.5 15L9 19.5M15 9h4.5V9M15 9v4.5M15 9L19.5 4.5M15 15h4.5M15 15v-4.5m0 4.5L19.5 19.5" />
                </svg>
              ) : (
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
                </svg>
              )}
            </button>

            {/* hum berger mode icon */}
            {!isGalleryPage && (
              <Hamburger
                toggled={toggle}
                size={22}
                duration={0.8}
                distance={"lg"}
                toggle={setToggle}
                color={darkMode ? "#000000" : "#ffffff"}
              />
            )}
          </div>
        </div>
      </nav>
      {/* Mobile view nav bar */}
      <AnimatePresence>
        {toggle && (
          <motion.div
            initial={{ x: 100 }}
            animate={{ x: 0, transition: { type: "spring" } }}
            exit={{ x: 200, transition: { type: "spring" } }}
            className={
              darkMode
                ? "bg-white py-2 px-2 md:p-0 z-50 fixed top-16 mt-2 rounded-lg shadow-lg right-2 block w-40"
                : "bg-black py-2 px-2 md:p-0 z-50 fixed top-16 mt-2 rounded-lg shadow-lg right-2 block w-40"
            }
          >
            <ul className=" md:flex-row md:space-y-8 md:mt-0 md:text-md md:font-medium">
              <NavLink
                to="/google-search"
                className={({ isActive }) =>
                  "d-block d-md-none " + // 👈 show only on mobile
                  (darkMode
                    ? "block py-2 px-3 rounded-md " +
                      (isActive
                        ? "bg-blue-500 text-white"
                        : "text-black hover:bg-blue-500 hover:text-white")
                    : "block py-2 px-3 rounded-md " +
                      (isActive
                        ? "bg-blue-500 text-white"
                        : "text-white hover:bg-blue-500 hover:text-black"))
                }
              >
                Google
              </NavLink>

              {Constant.links.map((el) => (
                <Link
                  key={el.name}
                  to={el.route}
                  activeClass={"text-white bg-blue-500"}
                  className={
                    darkMode
                      ? "hover:bg-blue-500 text-black block px-3 py-2 rounded-md text-base font-medium mt-1 hover:text-white"
                      : "hover:bg-blue-500 text-white block px-3 py-2 rounded-md text-base font-medium mt-1 hover:text-white"
                  }
                  // spy={true}
                  smooth={true}
                  onClick={() => setToggle(false)}
                >
                  <li key={el.name}>{el.name}</li>
                </Link>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;
